@if ($displayValue(); as displayValue) {
    {{ displayValue }}
}
